import { Component, inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { LoginFormComponent } from '../../components/login-form/login-form.component';
import { Router } from '@angular/router';
import { User } from '../../../core/models/entities/user';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-login-page',
  template: `
    <app-auth-template title="Connexion">
      <app-login-form
        [sendingData]="sendingData"
        (afterLogin)="afterLogin($event)"
      ></app-login-form>
    </app-auth-template>
  `,
  standalone: false,
})
export class LoginPageComponent {
  @ViewChild(LoginFormComponent) loginForm: LoginFormComponent;
  sendingData: boolean;
  platformId = inject(PLATFORM_ID);

  constructor(
    private router: Router,
    private title: Title,
  ) {
    this.title.setTitle('Location de salles - Se connecter');
  }

  async afterLogin(user: User) {
    const { redirect } = window.history.state;

    if (redirect) {
      await this.router.navigateByUrl(redirect);
    } else {
      await this.router.navigate(['/reservations']);
    }
  }
}
